import { Component, OnInit } from '@angular/core';
import { OrdinaryQuery } from 'private-angular-vhframeworks';


@Component({
  selector: 'app-news-home1-carousel',
  templateUrl: './news-home1-carousel.component.html',
  styleUrls: ['./news-home1-carousel.component.scss']
})
export class NewsHome1CarouselComponent implements OnInit {

  data: any = []
  constructor(
    private ordinaryQuery: OrdinaryQuery
  ) { }

  ngOnInit(): void {
    this.getNews()
  }

  getNews() {
    let n = 972
    this.ordinaryQuery.getTasks_by2Field_1Field1Value_AND_1Field1Value('news', 'status', "==", true, 'type', '==', '1')
      .then(res => {
        this.data = res.docs.map((item) => {
          item.view = n + Math.floor(Math.random() * n);
          return { id: item.id, ...item.data(), view: item.view }
        })
      })
  }


}
